module.exports = __webpack_public_path__ + "img/商城.f5d4d9e6.png";